<template>
  <div>
    <!-- 退出弹框 -->
    <modalDefaultBig
      :showModal="showModal"
      @close="close()"
      @confirm="confirm()"
      :modalText="
        curTabIndex == 0
          ? '全服记录'
          : curTabIndex == 1
          ? '个人记录'
          : '十佳掉落'
      "
      :showCancel="false"
      :showConfirm="false"
    >
      <template #dialogContent>
        <div class="drop-info-all">
          <div class="drop-list">
            <div class="drop-inner" @scroll="scrollEventFn">
              <div role="feed" class="van-list">
                <div
                  class="drop-item color-blue"
                  v-for="(item, index) in lists"
                  :key="index"
                >
                  <div class="open-time">{{ item.createTime }}</div>
                  <div class="item-c0 111">
                    <div class="head-box">
                      <img :src="$getFullPath(item.avatar)" class="head-img" />
                      <div class="head-mask"></div>
                    </div>
                    <div class="nick text-ellipsis">
                      {{ item.holderUserNickName }}
                    </div>
                  </div>
                  <div class="item-c1">
                    <div class="c1-name text-ellipsis">
                      {{ item.boxName }}
                    </div>
                    <div class="c1-price">
                      <img
                        src="../../assets/images/balance2.png"
                        class="coin"
                      />
                      <span>{{ item.boxPrice }}</span>
                    </div>
                    <div class="c1-time"></div>
                  </div>
                  <div class="item-c2">
                    <div class="c2-name text-ellipsis">
                      {{ item.ornamentName }}
                    </div>
                    <div class="c2-price">
                      <span>{{ item.ornamentsPrice }}</span>
                      <img
                        src="../../assets/images/balance2.png"
                        class="coin"
                      />
                    </div>
                  </div>
                  <div class="item-c3 flex-center">
                    <img :src="$getFullPath(item.imageUrl) " class="img" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template #bottomTab>
        <div
          @click="changeTab(0)"
          :class="[curTabIndex == 0 ? 'sel' : '']"
          class="tab-item"
        >
          全服记录
        </div>
        <div
          @click="changeTab(1)"
          :class="[curTabIndex == 1 ? 'sel' : '']"
          class="tab-item"
        >
          个人记录
        </div>
        <div
          @click="changeTab(2)"
          :class="[curTabIndex == 2 ? 'sel' : '']"
          class="tab-item"
        >
          十佳掉落
        </div>
      </template>
    </modalDefaultBig>
  </div>
</template>
    <script>
import { getBindBoxHistory, getUserBindBoxHistory, tenTop } from "@/api/index";
import modalDefaultBig from "@/components/common/modalDefaultBig.vue";
export default {
  name: "modalBoxDetail",
  components: {
    modalDefaultBig,
  },
  data() {
    return {
      lists: [],
      page: 1,
      limit: 10,
      isOver: false,
      curTabIndex: 0,
      orderByFie: 0,
      source: [1],
      status: [0, 2, 3, 5],
      page: 1,
      size: 20,
      userId: 0,
    };
  },
  props: {
    showModal: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    showModal(val) {
      if (val) {
        this.curTab = 0;
        this.dropLists = [];
        this.getBoxRecord();
      }
    },
  },
  methods: {
    close() {
      this.$emit("close");
    },
    confirm() {
      this.$emit("confirm");
    },
    // 切换tab
    changeTab(index) {
      this.curTabIndex = index;
      this.page = 1;
      this.isOver = false;
      this.lists = [];
      this.getBoxRecord();
    },
    getBoxRecord() {
      let params = {
        page: this.page,
        size: this.size,
        source: this.source,
        status: this.status,
        orderByFie: this.orderByFie,
      };
      const userInfo = this.$store.state.USER_INFO;
      if (this.curTabIndex == 1) {
        params.userId = userInfo.userId;
      }
      if (this.curTabIndex == 0) {
        this.getBindBoxHistoryFn(params);
      } else if (this.curTabIndex == 1) {
        this.getUserBindBoxHistoryFn(params);
      } else {
        this.getTenTop();
      }
    },
    getBindBoxHistoryFn(params) {
      // 如果已经加载完毕，则不再请求数据
      if (this.isOver) {
        this.$message({
          duration: 1000,
          message: "没有更多数据了",
          type: "warning",
          customClass: "log_warning",
        });
        return;
      }

      getBindBoxHistory(params).then((res) => {
        const newData = res.data.data;
        if (newData.length < this.size) {
          this.isOver = true; // 没有更多的数据
        } else {
          this.page++; // 增加页码，准备下一次请求
        }
        // 将新数据追加到已有的列表中
        this.lists = [...this.lists, ...newData];
      });
    },
    getUserBindBoxHistoryFn(params) {
      if (this.isOver) {
        this.$message({
          duration: 1000,
          message: "没有更多数据了",
          type: "warning",
          customClass: "log_warning",
        });
        return;
      }
      getBindBoxHistory(params).then((res) => {
        const newData = res.data.data;
        if (newData.length < this.size) {
          this.isOver = true;
        } else {
          this.page++;
        }
        this.lists = [...this.lists, ...newData];
      });
    },
    getTenTop() {
      if (this.isOver) return;
      tenTop().then((res) => {
        this.lists = res.data.data;
        this.isOver = true;
      });
    },
    scrollEventFn(e) {
      // console.log(e);
      this.event = e;
      if (
        e.srcElement.scrollTop + e.srcElement.clientHeight >=
        e.srcElement.scrollHeight
      ) {
        this.getBoxRecord();
      }
    },
  },
};
</script>
  <style scoped lang="scss">
.drop-info-all .drop-list {
  padding: 6.67 * 4.2px 4 * 4.2px 8 * 4.2px;
}

.drop-info-all .drop-list .drop-inner {
  height: 97.33 * 4.2px;
  overflow-y: scroll;
}

.drop-info-all .drop-list .drop-inner::-webkit-scrollbar {
  width: 0.67 * 4.2px;
  height: 0.67 * 4.2px;
}

.drop-info-all .drop-list .drop-inner::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.2);
}

.drop-info-all .drop-list .drop-item {
  position: relative;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  width: 89.87 * 4.2px;
  height: 16 * 4.2px;
  font-size: 3.33 * 4.2px;
  margin: 0 0 2.4 * 4.2px 0;
  background-size: 100% 100%;
  background-image: url("../../assets/images/drop_blue.png");
}

.drop-info-all .drop-list .drop-item.color-blue {
  background-image: url("../../assets/images/drop_blue.png");
}

.drop-info-all .drop-list .drop-item.color-purple {
  background-image: url("../../assets/images/drop_purple.png");
}

.drop-info-all .drop-list .drop-item.color-red {
  background-image: url("../../assets/images/drop_red.png");
}

.drop-info-all .drop-list .drop-item.color-golden {
  background-image: url("../../assets/images/drop_golden.png");
}

.drop-info-all .drop-list .drop-item .open-time {
  position: absolute;
  bottom: 0;
  right: 1.33 * 4.2px;
  width: 37.33 * 4.2px;
  height: 3.87 * 4.2px;
  line-height: 3.87 * 4.2px;
  margin: 0 0 0 5.2 * 4.2px;
}

.drop-info-all .drop-list .drop-item .item-c0 {
  width: 23.07 * 4.2px;
}

.drop-info-all .drop-list .drop-item .item-c0 .head-box {
  position: relative;
  width: 10.67 * 4.2px;
  height: 10.67 * 4.2px;
  margin: 1.07 * 4.2px 0 0 6.53 * 4.2px;
}

.drop-info-all .drop-list .drop-item .item-c0 .head-box .head-img {
  position: absolute;
  width: 100%;
  height: 100%;
  -webkit-border-radius: 50%;
  border-radius: 50%;
  top: 0;
  left: 0;
}

.drop-info-all .drop-list .drop-item .item-c0 .head-box .head-mask {
  position: absolute;
  width: 100%;
  height: 100%;
  background-size: 100% 100%;
  background-image: url("../../assets/images/head_bk.png");
}

.drop-info-all .drop-list .drop-item .item-c0 .nick {
  width: 18.67 * 4.2px;
  height: 3.2 * 4.2px;
  line-height: 3.2 * 4.2px;
  font-size: 2.67 * 4.2px;
  text-align: center;
  margin: 0.67 * 4.2px 0 0 2.8 * 4.2px;
}

.drop-info-all .drop-list .drop-item .item-c1 {
  width: 17.33 * 4.2px;
}

.drop-info-all .drop-list .drop-item .item-c1 .c1-name {
  height: 4 * 4.2px;
  line-height: 4 * 4.2px;
  width: 16.8 * 4.2px;
  color: #fff;
  margin: 2 * 4.2px 0 0 0;
}

.drop-info-all .drop-list .drop-item .item-c1 .c1-name .box-type {
  padding-right: 1.2 * 4.2px;
}

.drop-info-all .drop-list .drop-item .item-c1 .c1-price {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  height: 4 * 4.2px;
  line-height: 4 * 4.2px;
  font-size: 3.47 * 4.2px;
  color: #ffe3c2;
  margin-top: 2 * 4.2px;
}

.drop-info-all .drop-list .drop-item .item-c1 .c1-price .coin {
  float: left;
  width: 3.73 * 4.2px;
  height: 3.73 * 4.2px;
}

.drop-info-all .drop-list .drop-item .item-c2 {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  text-align: right;
  padding-left: 2.67 * 4.2px;
}

.drop-info-all .drop-list .drop-item .item-c2 .c2-name {
  height: 4 * 4.2px;
  line-height: 4 * 4.2px;
  width: 26.67 * 4.2px;
  color: #fff;
  margin-top: 2 * 4.2px;
}

.drop-info-all .drop-list .drop-item .item-c2 .c2-price {
  width: 26.67 * 4.2px;
  height: 4 * 4.2px;
  line-height: 4 * 4.2px;
  font-size: 3.47 * 4.2px;
  color: #ffe3c2;
  margin-top: 1.33 * 4.2px;
}

.drop-info-all .drop-list .drop-item .item-c2 .c2-price .coin {
  float: right;
  width: 3.73 * 4.2px;
  height: 3.73 * 4.2px;
}

.drop-info-all .drop-list .drop-item .item-c2 .c2-price text {
  float: right;
}

.drop-info-all .drop-list .drop-item .item-c3 {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  width: 17.33 * 4.2px;
  margin-right: 1.33 * 4.2px;
}

.drop-info-all .drop-list .drop-item .item-c3 .img {
  width: 13.33 * 4.2px;
  height: 13.33 * 4.2px;
  -o-object-fit: scale-down;
  object-fit: scale-down;
  margin-top: -1.6 * 4.2px;
}
</style>